import React, { useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import ProductSupplier from '../product-supplier/ProductSupplier';


function PopupNewSupplier({ open, setOpen, id, translate }) {
    const { dispatch, langLocal, navigate, mode } = AbstructVar()
    const [fields2, setFields2] = useState([
        {
            qty: '',
            cost: null,
            currency: '',
            date_of_supply: '',
            time_of_supply: '',
            place_of_supply: '',
            reason_of_supply: '',
            file_path: '',
            notes: ''
        }
    ])
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `pop_center2 ff ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className='pop_center2' >
                <ProductSupplier noBorder noPlus fields={fields2} setFields={setFields2} />
            </div>
        </RModal>
    )
}

export default PopupNewSupplier